





















































import { Component, Vue, Prop, Provide, Emit } from "vue-property-decorator";
import { State, Getter, namespace } from "vuex-class";

import SidebarFooter from "./SidebarFooter.vue";
import SidebarForm from "./SidebarForm.vue";
import SidebarHeader from "./SidebarHeader.vue";
import SidebarMinimizer from "./SidebarMinimizer.vue";
import SidebarNavDivider from "./SidebarNavDivider.vue";
import SidebarNavDropdown from "./SidebarNavDropdown.vue";
import SidebarNavLink from "./SidebarNavLink.vue";
import SidebarNavTitle from "./SidebarNavTitle.vue";
import SidebarNavItem from "./SidebarNavItem.vue";
import SidebarNavLabel from "./SidebarNavLabel.vue";

const UserModule = namespace("userModule");

@Component({
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel
  }
})
export default class Sidebar extends Vue {
  @UserModule.Getter public isAdmin;

  @Prop({ default: () => [] })
  public navItems: any[];

  @Provide() public navItemList: any[] = [];

  @Emit()
  public handleClic(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle("open");
  }

  public created() {
    this.navItemList = this.filteredNavItems;
  }

  get filteredNavItems() {
    if (this.isAdmin) {
      return this.navItems;
    }

    const items = this.navItems.filter((obj) => {
      return obj.role !== "Admin";
    });

    return items;
  }
}
